import { render } from "./PaperUsage.vue?vue&type=template&id=3e110e90"
import script from "./PaperUsage.vue?vue&type=script&lang=js"
export * from "./PaperUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__